module.exports = __webpack_public_path__ + "static/media/pinksmall.4991d76d.svg";